import { render, staticRenderFns } from "./FrzChamberPaletized.vue?vue&type=template&id=b0314a1e"
import script from "./FrzChamberPaletized.vue?vue&type=script&lang=js"
export * from "./FrzChamberPaletized.vue?vue&type=script&lang=js"
import style0 from "./FrzChamberPaletized.vue?vue&type=style&index=0&id=b0314a1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports